import * as Yup from 'yup';

export default Yup.object()
  .shape({
    reason: Yup.string()
      .trim()
      .min(50, 'Must be at least 50 characters')
      .required('A detailed reason is required'),
  });
